import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueGoogleCharts from "vue-google-charts/legacy";
// import VueSocketIO from "vue-socket.io";
// import SocketIO from "socket.io-client";
import VueQriously from "vue-qriously";
import VueI18n from 'vue-i18n'
import en from './assets/locales/en.json'
import de from './assets/locales/de.json'
import es from './assets/locales/es.json'
import fr from './assets/locales/fr.json'
import VCalendar from 'v-calendar';
import vPagination from 'vue-plain-pagination'
Vue.component('v-pagination', vPagination);
import { VueReCaptcha } from 'vue-recaptcha-v3'

const key = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
// For more options see below
Vue.use(VueReCaptcha, { siteKey: key })

import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect)
const messages = { en, de, es, fr }

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en',
  messages,
  silentTranslationWarn: true, // TODO remove and fix translations

});

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.use(VueQriously);

Vue.use(VueGoogleCharts);

// const socketConnection = SocketIO("http://localhost:5002");

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
// Vue.use(new VueSocketIO({ connection: socketConnection }));

Vue.config.productionTip = false;

// Require static css files
// require('@/assets/css/bootstrap.min.css');
require('@/assets/css/font-awesome-all.min.css');
require('@/assets/css/charts.min.css');
require('@/assets/css/datatables.min.css');
// require('@/dist/css/jvector-map.min.css');
require('@/assets/css/fancy-box.min.css');
require('@/assets/css/nice-select.min.css');
require('@/assets/css/pikaday.min.css');
require('@/assets/css/reset.css');
require('@/assets/css/style.css');
require('@/dist/main.css');

new Vue({
  router,
  store,
  render: (h) => h(App),
  i18n,
}).$mount("#app");
